// Compares two addresses by `place_id` only. Manually-typed addresses
// without a place_id will not match — accepted false-negative bias for MVP.

export type AddressLike = { place_id?: string | null };

export function addressEquals(a: AddressLike, b: AddressLike): boolean {
  if (!a.place_id || !b.place_id) return false;
  return a.place_id === b.place_id;
}
